import { Transform } from "class-transformer";
import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { toEuros } from "@/utils/numberUtils";

export class SupplierInvoiceLineDto extends BaseEntityDto {
  concept: string;

  quantity: number;

  @Transform(({ value }) => toEuros(value))
  unitPrice: number;

  @Transform(({ value }) => toEuros(value))
  totalPrice: number;

  supplierInvoiceId: string;
}
